
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title 
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Satrane Uddane Hunkar Vadani" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Satrane Uddane Hunkar Vadani" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Satrane Uddane Hunkar Vadani, hanuman Aarti lyrics, Hunkar Vadani Aarti, Bajrangbali Aarti, satrane uddane hunkar vadani aarti in english, satrane uddane hunkar vadani aarti in marathi'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Satrane Uddane Hunkar Vadani Aarti, Aarti of Lord Hanuman, Satrane Uddane Aarti, Hanuman Bhakti Geet, Marathi Aarti, Hanuman Aarti lyrics, Hunkar Vadani Aarti, Bajrangbali Aarti, Hanuman prayer, Satrane Uddane Aarti lyrics, Lord Hanuman worship, Hindu Aarti, Devotional Aarti, Aarti in Marathi, Hanuman Bhajan, Maruti Stotra, हनुमंताची आरती सत्राणे उड्डाणे, हनुमान आरती मराठी, मारुतीची आरती, satrane uddane hunkar vadani aarti in english, satrane uddane hunkar vadani aarti in marathi'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/maruti.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/maruti.webp'
          },
          ],
        }
      },
    
      components: {
        },
        data() {
          return {
            title: 'Satrane Uddane Hunkar Vadani | Maruti Aarti - सत्राणें उड्डाणें हुंकार वदनीं(मारुतीची आरती)',
            langauageMarathi: true
          }
        },
        layout: 'detailsPage-withoutFooter',
    
        jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/maruti"
        },
        "headline": "Satrane Uddane Hunkar Vadani - सत्राणें उड्डाणें हुंकार वदनीं(मारुतीची आरती)",
        "name" : "Satrane Uddane Hunkar Vadani - Maruti Aarti",
        "description": "Explore the full lyrics of Aarti 'Satrane Uddane Hunkar Vadani' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/maruti.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
    
    
        computed: {
    
        },
        methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
    
      }
    